import { Schemas } from '../models/entities';

import * as ActionTypes from './types';

const fetchCards = (pageSize, pageNumber, sortBy, sortDesc, query) => ({
  [ActionTypes.API_CALL]: {
    method: 'GET',
    types: [
      ActionTypes.FETCH_CARDS_REQUEST,
      ActionTypes.FETCH_CARDS_SUCCESS,
      ActionTypes.FETCH_CARDS_FAILURE,
    ],
    schema: Schemas.CARD_ARRAY,
    endpoint: `/api/paymentinfo/paymentcard?page=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy || ''}&sortDesc=${sortDesc}&search=${query ? encodeURI(query) : ''}`,
  },
});

export const loadCards = (query) => (dispatch, getState) => {
  const {
    pageSize = 10,
    pageNumber = 0,
  } = getState().pagination.cards || {};
  const {
    sortBy = null,
    sortDesc = false,
  } = getState().sorting.cards || {};
  return dispatch(fetchCards(pageSize, pageNumber, sortBy, sortDesc, query));
};

const postCard = (body) => ({
  [ActionTypes.API_CALL]: {
    method: 'POST',
    types: [
      ActionTypes.ADD_CARD_REQUEST,
      ActionTypes.ADD_CARD_SUCCESS,
      ActionTypes.ADD_CARD_FAILURE,
    ],
    endpoint: '/api/paymentinfo/paymentcard',
    body,
  },
});

export const addCard = (card) => (dispatch) => dispatch(postCard(card));

const putCard = (card) => ({
  [ActionTypes.API_CALL]: {
    method: 'PUT',
    types: [
      ActionTypes.UPDATE_CARD_REQUEST,
      ActionTypes.UPDATE_CARD_SUCCESS,
      ActionTypes.UPDATE_CARD_FAILURE,
    ],
    endpoint: `/api/paymentinfo/${card.id}`,
    body: card,
  },
});

export const updateCard = (card) => (dispatch) => dispatch(putCard(card));

const removeCard = (id) => ({
  [ActionTypes.API_CALL]: {
    method: 'DELETE',
    types: [
      ActionTypes.DELETE_CARD_REQUEST,
      ActionTypes.DELETE_CARD_SUCCESS,
      ActionTypes.DELETE_CARD_FAILURE,
    ],
    endpoint: `/api/paymentinfo/${id}`,
  },
});

export const deleteCard = (id) => (dispatch) => dispatch(removeCard(id));

const patchDeactivateCard = (id) => ({
  [ActionTypes.API_CALL]: {
    method: 'PATCH',
    types: [
      ActionTypes.DEACTIVATE_CARD_REQUEST,
      ActionTypes.DEACTIVATE_CARD_SUCCESS,
      ActionTypes.DEACTIVATE_CARD_FAILURE,
    ],
    endpoint: `/api/paymentinfo/${id}/deactivate`,
  },
});

export const deactivateCard = (id) => (dispatch) => dispatch(patchDeactivateCard(id));

const patchActivateCard = (id) => ({
  [ActionTypes.API_CALL]: {
    method: 'PATCH',
    types: [
      ActionTypes.ACTIVATE_CARD_REQUEST,
      ActionTypes.ACTIVATE_CARD_SUCCESS,
      ActionTypes.ACTIVATE_CARD_FAILURE,
    ],
    endpoint: `/api/paymentinfo/${id}/activate`,
  },
});

export const activateCard = (id) => (dispatch) => dispatch(patchActivateCard(id));
